<script setup lang="ts">

</script>

<template>
  <div class="back">
    <div class="box"></div>
    <div class="box1"></div>
  </div>

</template>

<style scoped lang="scss">
$box-size:2dvh;
$color1:#2B2B2B;
$color2:#303030;
$color3: rgba(43, 43, 43, 0);
.back {
  user-select: none;
  display: flex;
  flex-direction: column; // 让子元素垂直排列
  justify-content: center; // 让子元素上下居中
  align-items: stretch; // 让子元素左右占满
  width: 100%;
  height: 8dvh;
  background: $color1;
}

.box {
  width: 100%;
  height: $box-size;
  background: repeating-linear-gradient(
          90deg,
          $color2 0px,
          $color2 $box-size,
          $color3 $box-size,
          $color3 2*$box-size
  );
}
.box1 {
  width: 100%;
  height: $box-size;
  background: repeating-linear-gradient(
          90deg,
          $color3 0px,
          $color3 $box-size,
          $color2 $box-size,
          $color2 2*$box-size
  );
}
</style>
